document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.reference-gallery-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            enabled: true,
        },
        breakpoints: {
            992: {
                slidesPerView: 4,
            }
        }
    });
});
